module.exports = __webpack_public_path__ + "img/illustration_reference_dialog.e1b71c05.png";